import React from 'react';
import { theme } from 'antd';
import PropTypes from 'prop-types';

import HashLoader from 'react-spinners/HashLoader';

import './style.scss';

const BlockLoading = ({ overlay, text }) => {
	const {
		token: { colorPrimary, colorBgMask, zIndexPopupBase },
	} = theme.useToken();

	if (overlay) {
		return (
			<div
				className="block-loading-overlay"
				style={{
					// gunakan token antd untuk mask & z-index biar konsisten dg Modal/Drawer
					backgroundColor: colorBgMask,
					zIndex: (zIndexPopupBase ?? 1000) + 10,
				}}
				aria-busy="true"
				role="status"
				aria-live="polite"
			>
				<div className="block-loading-content">
					<HashLoader color={colorPrimary} />
					{text ? <div className="block-loading-text">{text}</div> : null}
				</div>
			</div>
		);
	}

	return (
		<div className="block-loading-container">
			<HashLoader color={colorPrimary} />
		</div>
	);
};

BlockLoading.defaultProps = {
	overlay: false,
	text: null,
};

BlockLoading.propTypes = {
	overlay: PropTypes.bool,
	text: PropTypes.string,
};

export default BlockLoading;
